// Filters an array to return only elements that DO NOT contain an attribute
function filterArrayWithoutAttribute(array, attribute) {
    return array.filter((e) => { return !e.hasOwnProperty(attribute) ? e : false; });
}

function filterArrayWithNode(cvNodes, nodes) {
    let filteredList = [];
    nodes.forEach(function(nItem) {
        cvNodes.map(function(cvItem) {
            if (cvItem.label === nItem.node) {
                cvItem.attributes.map(function(attribute) {
                    return filteredList.push({
                        "name": nItem.node + ":" + attribute.label,
                        "alias": nItem.alias
                    });
                })
            }
            return cvItem;
        });
    });
    return filteredList;
}
export { filterArrayWithoutAttribute, filterArrayWithNode };



// WEBPACK FOOTER //
// ./src/utils/array.js